export function idsMatch(a, b) {
    return a != null && b != null && String(a) === String(b);
}

export function getProjectFamilyIds(project) {
    if (!project) return [];
    if (Array.isArray(project.familyLinks) && project.familyLinks.length > 0) {
        return project.familyLinks.map(link => link.productFamilyId);
    }
    return project.linkedFamilies || [];
}

export function projectHasFamily(project, familyId) {
    return getProjectFamilyIds(project).some(id => idsMatch(id, familyId));
}

export function getFamilyShareInfo(familyId, projects = []) {
    const links = [];

    projects.forEach(project => {
        const familyLinks = project.familyLinks;
        if (Array.isArray(familyLinks) && familyLinks.length > 0) {
            const match = familyLinks.find(link => idsMatch(link.productFamilyId, familyId));
            if (match) {
                links.push({ project, linkedAt: match.linkedAt || project.createdAt });
                return;
            }
        }

        if (projectHasFamily(project, familyId)) {
            links.push({ project, linkedAt: project.createdAt });
        }
    });

    links.sort((a, b) => new Date(a.linkedAt).getTime() - new Date(b.linkedAt).getTime());

    return {
        isShared: links.length > 1,
        originalProject: links[0]?.project || null,
        projects: links.map(link => link.project)
    };
}

export function countSharedFamilies(selectedProject, projects = []) {
    const familyIds = selectedProject?.families?.map(family => family.id) || getProjectFamilyIds(selectedProject);
    return familyIds.filter(id => getFamilyShareInfo(id, projects).isShared).length;
}

export function getShareTooltip(shareInfo) {
    if (!shareInfo?.isShared) return '';
    const originalName = shareInfo.originalProject?.name || 'Unknown';
    const otherNames = shareInfo.projects
        .filter(project => !idsMatch(project.id, shareInfo.originalProject?.id))
        .map(project => project.name);
    const others = otherNames.length > 0 ? ` Also in: ${otherNames.join(', ')}.` : '';
    return `This family is shared. Changes will apply to all projects using it. Original in ${originalName}.${others}`;
}
